import { render } from "./ExpenseCategoryForm.vue?vue&type=template&id=79fe1460&ts=true"
import script from "./ExpenseCategoryForm.vue?vue&type=script&lang=ts"
export * from "./ExpenseCategoryForm.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__